export const Types = {
    SET_CHAIN_ID: 'SET_CHAIN_ID',
    SET_WEB3: 'SET_WEB3',
    SET_ETH_WEB3: 'SET_ETH_WEB3',
    SET_POL_WEB3: 'SET_POL_WEB3',
    SET_ONBOARD: 'SET_ONBOARD',
    SET_WALLET_ADDRESS: 'SET_WALLET_ADDRESS',
    SET_CONNECTED: 'SET_CONNECTED'
}